import type { WorkBook } from 'xlsx';
import type { SpreadsheetGridInput } from 'models/SpreadsheetDocument';
import { extractSheetAsGrid } from 'pages/SiteSettingsPage/excelImport';

export interface WorkbookSheetIssue {
  sheetName: string;
  message: string;
}

/** 시트별 열 구성을 유지하고, 빈 시트나 읽기 실패가 다른 시트의 등록을 막지 않도록 한다. */
export function readWorkbookSheets(
  workbook: WorkBook,
  sheetNames: string[],
  importGrid?: (grid: SpreadsheetGridInput) => SpreadsheetGridInput | string,
): {
  sheets: { sheetName: string; grid: SpreadsheetGridInput }[];
  issues: WorkbookSheetIssue[];
} {
  const sheets: { sheetName: string; grid: SpreadsheetGridInput }[] = [];
  const issues: WorkbookSheetIssue[] = [];
  for (const sheetName of sheetNames) {
    try {
      const rawGrid = extractSheetAsGrid(workbook, sheetName);
      if (!rawGrid.headers.length || !rawGrid.dataRows.length) {
        throw new Error('가져올 데이터가 없습니다(빈 시트).');
      }
      const grid = importGrid ? importGrid(rawGrid) : rawGrid;
      if (typeof grid === 'string') throw new Error(grid);
      if (!grid.headers.length || !grid.dataRows.length) {
        throw new Error('가져올 데이터가 없습니다(빈 시트).');
      }
      sheets.push({ sheetName, grid });
    } catch (error) {
      issues.push({
        sheetName,
        message: error instanceof Error ? error.message : '시트 읽기 실패',
      });
    }
  }
  return { sheets, issues };
}
